import * as STD from '@emersya/mpa-std-lib';
import CM                     from '@emersya/mpa-components-manager-lib';
import { InputButton, Image } from '@emersya/mpa-components-lib';

export interface IOMSProcessButtonComponentConfiguration extends InputButton.Configuration {
};

export class OMSProcessButtonComponent extends InputButton.Component {
	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		const tr = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
			a[ c ] = 'icon process order';
			return a;
		}, {});
		const image = await this.component_instantiateOuterChild<Image.Configuration>(
			{
				type :          'image',
				id :            'icon',
				tree :          this.component_tree,
				slot :          null,
				isSlot :        false,
				declaredSlot :  null,
				configuration : {
					URL :             '$ASSETS/UI-Icons-Right.svg'.replace('$ASSETS/', app.clientAppParameters.app.assetsPath).replace('CH1U0ZGKSI', 'E3GC4QDIZW').replace('XUJG0A2TF5', 'STAODAZNIS').replace('sam1_12345','STAODAZNIS'),
					'@translations' : {
						name : tr
					}
				}
			}
		);
		void image;
		await super.component_start(ev);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IOMSProcessButtonComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = OMSProcessButtonComponent;
	export type Component = OMSProcessButtonComponent;
	export type Configuration = IOMSProcessButtonComponentConfiguration;
}
import manifestXMLSource from './OMSProcessButton.xml';
import './OMSProcessButton.scss';

CM.declare({
	id :       'oms-processButton',
	type :     OMSProcessButtonComponent,
	manifest : manifestXMLSource
});
